import React from 'react';
import { Icon, IconType } from 'components/common/Icon';

export const MenuItemIcon = ({ type }: { type: IconType }) => {
  return <Icon className="menu-item-icon" type={type} />;
};

export const MenuItemImg = ({ imgUrl }: { imgUrl: string }) => {
  return <div className="menu-item-icon menu-item-img" style={{ backgroundImage: `url(${imgUrl})` }} />;
};